import { render, staticRenderFns } from "./DoctorDashboard.vue?vue&type=template&id=faed5680"
import script from "./DoctorDashboard.vue?vue&type=script&lang=js"
export * from "./DoctorDashboard.vue?vue&type=script&lang=js"
import style0 from "./DoctorDashboard.vue?vue&type=style&index=0&id=faed5680&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports